import type { Odpoved } from '../api/JsdhNotifikaceService/generated/models/Odpoved';
import type { ZalohaJinde } from '../api/JsdhNotifikaceService/generated/models/ZalohaJinde';

/** Clen ve skupine „V zaloze“: bud odpoved tohoto poplachu, nebo zaloha z jineho poplachu. */
export interface ZalohaPolozka {
    odpoved?: Odpoved;
    jinde?: ZalohaJinde;
}

/** Stabilni identita prazdne zalohy odjinud — novy [] pri kazdem renderu by rozbil useMemo volajicich. */
export const BEZ_ZALOHY: ZalohaJinde[] = [];

export interface RozdeleneOdpovedi {
    /** JEDU bez zalohy — jedou s vozem; jen z nich se pocitaji role, plomba a dojezd. */
    jedou: Odpoved[];
    zaloha: ZalohaPolozka[];
    nejedou: Odpoved[];
}

/**
 * Jedine misto, kde kiosk deli odpovedi na Jedou / V zaloze / Nejedou (spec § 5.2).
 * Pouzivaji ho vsechny tri renderovaci cesty (vyjezd-2026, technika-ucast, standard).
 */
export function rozdelOdpovedi(odpovedi: Odpoved[], zalohaJinde: ZalohaJinde[]): RozdeleneOdpovedi {
    const jedou: Odpoved[] = [];
    const zaloha: ZalohaPolozka[] = [];
    const nejedou: Odpoved[] = [];

    const vZalozeTady = new Set<number>();
    for (const o of odpovedi) {
        if (o.odpoved === 'JEDU' && o.zalohaAktivni === true) {
            zaloha.push({ odpoved: o });
            vZalozeTady.add(o.uzivatelId);
        }
    }

    // Rucni odpoved u tohoto poplachu ma prednost pred zalohou odjinud. Automaticke
    // NEJEDU (dostupnost, pohotovost, HZS) fyzickou pritomnost ve zbrojnici neprebiji.
    const rucneOdpovedeli = new Set(
        odpovedi.filter((o) => o.automaticka !== true).map((o) => o.uzivatelId),
    );
    const prevzati = new Set<number>();
    for (const z of zalohaJinde) {
        if (vZalozeTady.has(z.uzivatelId) || prevzati.has(z.uzivatelId)) continue;
        if (rucneOdpovedeli.has(z.uzivatelId)) continue;
        prevzati.add(z.uzivatelId);
        zaloha.push({ jinde: z });
    }

    for (const o of odpovedi) {
        if (o.odpoved === 'JEDU') {
            if (o.zalohaAktivni !== true) jedou.push(o);
        } else if (o.odpoved === 'NEJEDU' && !prevzati.has(o.uzivatelId)) {
            nejedou.push(o);
        }
    }

    return { jedou, zaloha, nejedou };
}

export const jmenoZalohy = (p: ZalohaPolozka): string => p.odpoved?.jmeno ?? p.jinde?.jmeno ?? '';

export const klicZalohy = (p: ZalohaPolozka): string =>
    p.odpoved ? `odpoved-${p.odpoved.id}` : `jinde-${p.jinde?.uzivatelId ?? 0}`;
